import React, { useEffect } from 'react';
import { Versioning } from './versioning';
import { List } from './list';
import { useDispatch, useSelector } from "react-redux";
import * as R from 'ramda';

import * as Loadings from '../../constants/loadings/account';
import { LoadingBall } from '../_common/loadingBall';
import { getApplications } from '../../actions/account-api';

const Services = () => {
    const account = useSelector(state => state.account);
    const dispatch = useDispatch();

    useEffect(() => {
        if (R.isNil(account.applications)) {
            dispatch(getApplications());
        }
        // eslint-disable-next-line
    }, [account.applications]);

    if (account.isLoading.includes(Loadings.FETCH_APPLICATIONS)) {
        return <LoadingBall />;
    }
    if (R.isNil(account.applications)) {
        return null;
    }

    return (
        <div className="row gx-0 gy-3 h-100">
            <div className="col-12 col-lg h-inherit order-last order-lg-first">
                <List />
            </div>
            <div className="col-12 col-lg-auto h-inherit">
                <Versioning />
            </div>
        </div>
    );

};

export default Services;